
// src/components/admin/page-management/section-forms/SlideShowHeaderWaveForm.js
import React, { useState } from 'react';
import { Info } from 'lucide-react';
import ColorPicker from '../../shared/ColorPicker';
import MediaLibrary from '../../shared/MediaUploader';

const SlideShowHeaderWaveForm = ({ content, updateContent, pageSlug }) => {
  const [showMediaLibrary, setShowMediaLibrary] = useState(false);
  const [currentImageField, setCurrentImageField] = useState(null);
  const [currentMediaType, setCurrentMediaType] = useState('image'); // Add this line

  const handleSelectImage = (imageUrl) => {
    if (currentImageField) {
      updateContent(currentImageField, imageUrl);
      setShowMediaLibrary(false);
      setCurrentImageField(null);
    }
  };

  // const openMediaLibrary = (fieldName) => {
  //   setCurrentImageField(fieldName);
  //   setShowMediaLibrary(true);
  // };

  // Updated to include mediaType parameter
  const openMediaLibrary = (fieldName, mediaType = 'image') => {
    setCurrentImageField(fieldName);
    setCurrentMediaType(mediaType); // Set the current media type
    setShowMediaLibrary(true);
  };

  return (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold">Hero Banner Section</h3>
      
      {showMediaLibrary ? (
        <div className="bg-white rounded-lg shadow-lg p-4">
          <div className="flex justify-between items-center mb-4">
            <h4 className="text-lg font-medium">Media Library</h4>
            <button 
              onClick={() => setShowMediaLibrary(false)}
              className="text-gray-500 hover:text-gray-700"
            >
              Close
            </button>
          </div>
          {/* <MediaLibrary 
            onSelect={handleSelectImage} 
            pageSlug={pageSlug} 
          /> */}
          {/* Pass the media type to the MediaUploader */}
          <MediaLibrary 
            onUploadComplete={handleSelectImage} 
            type={currentMediaType} // This is the important change
            pageSlug={pageSlug} 
          />
        </div>
      ) : (
        <>
          {/* Content and Text Settings */}
          <div className="bg-gray-50 p-4 rounded-md">
            <h4 className="font-medium mb-4">Content</h4>
            
            <div className="mb-4">
              <label className="block text-sm font-medium mb-1">Title</label>
              <input
                type="text"
                value={content?.title || 'Paper Bag & Box <span>Custom Packaging</span>'}
                onChange={(e) => updateContent('title', e.target.value)}
                className="w-full p-2 border rounded"
              />
              <p className="text-xs text-gray-500 mt-1">
                Use &lt;span&gt;text&lt;/span&gt; to highlight parts of the title
              </p>
            </div>
            
            <div className="mb-4">
              <label className="block text-sm font-medium mb-1">Subtitle</label>
              <textarea
                value={content?.subtitle || 'Elevate your brand with premium quality custom bags and boxes. Perfect for businesses of all sizes.'}
                onChange={(e) => updateContent('subtitle', e.target.value)}
                className="w-full p-2 border rounded"
                rows="3"
              />
            </div>
            
            <div className="mb-4">
              <label className="block text-sm font-medium mb-1">Highlight Color</label>
              <ColorPicker
                color={content?.highlightColor || '#f59e0b'}
                onChange={(color) => updateContent('highlightColor', color)}
              />
            </div>
          </div>

          {/* Background Settings */}
          <div className="bg-gray-50 p-4 rounded-md">
            <h4 className="font-medium mb-4">Background Settings</h4>


            <div className="mb-4">
              <label className="block text-sm font-medium mb-1">Background Type</label>
              <div className="flex space-x-4">
                <label className="inline-flex items-center">
                  <input
                    type="radio"
                    name="backgroundType"
                    checked={!content?.videoBackground}
                    onChange={() => updateContent('videoBackground', false)}
                    className="mr-2"
                  />
                  <span className="text-sm">Image</span>
                </label>
                <label className="inline-flex items-center">
                  <input
                    type="radio"
                    name="backgroundType"
                    checked={!!content?.videoBackground}
                    onChange={() => updateContent('videoBackground', true)}
                    className="mr-2"
                  />
                  <span className="text-sm">Video</span>
                </label>
              </div>
            </div>


            {!content?.videoBackground ? (
              // Image background options (your existing code)
              <>
                <div className="mb-4">
                  <label className="block text-sm font-medium mb-1">Desktop Background Image</label>
                  {/* Existing image upload code */}
                </div>
                
                <div className="mb-4">
                  <label className="block text-sm font-medium mb-1">Mobile Background Image</label>
                  {/* Existing mobile image upload code */}
                </div>
              </>
            ) : (
              // Video background options
              <>
                <div className="mb-4">
                  <label className="block text-sm font-medium mb-1">Desktop Background Video</label>
                  <div className="flex items-center">
                    <input
                      type="text"
                      value={content?.backgroundVideo || ''}
                      onChange={(e) => updateContent('backgroundVideo', e.target.value)}
                      className="w-full p-2 border rounded"
                    />
                    <button
                      type="button"
                      onClick={() => openMediaLibrary('backgroundVideo', 'video')}
                      className="ml-2 px-3 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                    >
                      Browse
                    </button>
                  </div>
                  {content?.backgroundVideo && (
                    <div className="mt-2 relative h-20 w-full overflow-hidden rounded border">
                      <video 
                        src={content.backgroundVideo} 
                        className="h-full w-full object-cover"
                        controls
                      />
                    </div>
                  )}
                </div>
                
                <div className="mb-4">
                  <label className="block text-sm font-medium mb-1">Mobile Background Video</label>
                  <div className="flex items-center">
                    <input
                      type="text"
                      value={content?.mobileBackgroundVideo || ''}
                      onChange={(e) => updateContent('mobileBackgroundVideo', e.target.value)}
                      className="w-full p-2 border rounded"
                    />
                    <button
                      type="button"
                      onClick={() => openMediaLibrary('mobileBackgroundVideo', 'video')}
                      className="ml-2 px-3 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                    >
                      Browse
                    </button>
                  </div>
                  {content?.mobileBackgroundVideo && (
                    <div className="mt-2 relative h-20 w-full overflow-hidden rounded border">
                      <video 
                        src={content.mobileBackgroundVideo} 
                        className="h-full w-full object-cover"
                        controls
                      />
                    </div>
                  )}
                </div>
                
                <div className="mb-4">
                  <label className="block text-sm font-medium mb-1">Video Poster Image (Fallback)</label>
                  <div className="flex items-center">
                    <input
                      type="text"
                      value={content?.videoPoster || ''}
                      onChange={(e) => updateContent('videoPoster', e.target.value)}
                      className="w-full p-2 border rounded"
                    />
                    <button
                      type="button"
                      onClick={() => openMediaLibrary('videoPoster')}
                      className="ml-2 px-3 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                    >
                      Browse
                    </button>
                  </div>
                </div>
                
                <div className="grid grid-cols-3 gap-4">
                  <div className="mb-4">
                    <label className="flex items-center">
                      <input
                        type="checkbox"
                        checked={content?.videoAutoplay !== false}
                        onChange={(e) => updateContent('videoAutoplay', e.target.checked)}
                        className="mr-2"
                      />
                      <span className="text-sm">Autoplay</span>
                    </label>
                  </div>
                  <div className="mb-4">
                    <label className="flex items-center">
                      <input
                        type="checkbox"
                        checked={content?.videoLoop !== false}
                        onChange={(e) => updateContent('videoLoop', e.target.checked)}
                        className="mr-2"
                      />
                      <span className="text-sm">Loop</span>
                    </label>
                  </div>
                  <div className="mb-4">
                    <label className="flex items-center">
                      <input
                        type="checkbox"
                        checked={content?.videoMuted !== false}
                        onChange={(e) => updateContent('videoMuted', e.target.checked)}
                        className="mr-2"
                      />
                      <span className="text-sm">Muted</span>
                    </label>
                  </div>
                </div>
              </>
            )}
            
            <div className="mb-4">
              <label className="block text-sm font-medium mb-1">Desktop Background Image</label>
              <div className="flex items-center">
                <input
                  type="text"
                  value={content?.backgroundImage || '/images/s1.jpg'}
                  onChange={(e) => updateContent('backgroundImage', e.target.value)}
                  className="w-full p-2 border rounded"
                />
                <button
                  type="button"
                  onClick={() => openMediaLibrary('backgroundImage')}
                  className="ml-2 px-3 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                >
                  Browse
                </button>
              </div>
              {content?.backgroundImage && (
                <div className="mt-2 relative h-20 w-full overflow-hidden rounded border">
                  <img 
                    src={content.backgroundImage} 
                    alt="Background Preview" 
                    className="h-full w-full object-cover"
                  />
                </div>
              )}
            </div>
            
            <div className="mb-4">
              <label className="block text-sm font-medium mb-1">Mobile Background Image</label>
              <div className="flex items-center">
                <input
                  type="text"
                  value={content?.mobileBackgroundImage || '/images/s3.jpg'}
                  onChange={(e) => updateContent('mobileBackgroundImage', e.target.value)}
                  className="w-full p-2 border rounded"
                />
                <button
                  type="button"
                  onClick={() => openMediaLibrary('mobileBackgroundImage')}
                  className="ml-2 px-3 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                >
                  Browse
                </button>
              </div>
              {content?.mobileBackgroundImage && (
                <div className="mt-2 relative h-20 w-full overflow-hidden rounded border">
                  <img 
                    src={content.mobileBackgroundImage} 
                    alt="Mobile Background Preview" 
                    className="h-full w-full object-cover"
                  />
                </div>
              )}
            </div>
            
            <div className="mb-4">
              <label className="block text-sm font-medium mb-1">Overlay Color</label>
              <ColorPicker
                color={content?.overlayColor || 'rgba(0,0,0,0.5)'}
                onChange={(color) => updateContent('overlayColor', color)}
                allowAlpha={true}
              />
            </div>
            
            <div className="grid grid-cols-2 gap-4 mb-4">
              <div>
                <label className="block text-sm font-medium mb-1">Height</label>
                <input
                  type="text"
                  value={content?.height || '100vh'}
                  onChange={(e) => updateContent('height', e.target.value)}
                  className="w-full p-2 border rounded"
                  placeholder="e.g., 100vh, 800px"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Min Height</label>
                <input
                  type="text"
                  value={content?.minHeight || '600px'}
                  onChange={(e) => updateContent('minHeight', e.target.value)}
                  className="w-full p-2 border rounded"
                  placeholder="e.g., 600px"
                />
              </div>
            </div>
          </div>
          
          {/* Primary Button Settings */}
          <div className="bg-gray-50 p-4 rounded-md">
            <h4 className="font-medium mb-4">Primary Button</h4>
            
            <div className="mb-4">
              <label className="block text-sm font-medium mb-1">Button Text</label>
              <input
                type="text"
                value={content?.primaryButtonText || 'Customize Products'}
                onChange={(e) => updateContent('primaryButtonText', e.target.value)}
                className="w-full p-2 border rounded"
              />
            </div>
            
            <div className="mb-4">
              <label className="block text-sm font-medium mb-1">Button Link</label>
              <input
                type="text"
                value={content?.primaryButtonLink || '/products'}
                onChange={(e) => updateContent('primaryButtonLink', e.target.value)}
                className="w-full p-2 border rounded"
                placeholder="e.g., /products"
              />
            </div>
            
            <div className="mb-4">
              <label className="block text-sm font-medium mb-1">Button Color</label>
              <ColorPicker
                color={content?.primaryButtonColor || '#d97706'}
                onChange={(color) => updateContent('primaryButtonColor', color)}
              />
            </div>
          </div>
          
          {/* Secondary Button Settings */}
          <div className="bg-gray-50 p-4 rounded-md">
            <h4 className="font-medium mb-4">Secondary Button</h4>
            
            <div className="mb-4">
              <label className="block text-sm font-medium mb-1">Button Text</label>
              <input
                type="text"
                value={content?.secondaryButtonText || 'Call to Order'}
                onChange={(e) => updateContent('secondaryButtonText', e.target.value)}
                className="w-full p-2 border rounded"
              />
              <p className="text-xs text-gray-500 mt-1">Leave empty to hide the secondary button</p>
            </div>
            
            <div className="mb-4">
              <label className="block text-sm font-medium mb-1">Button Link</label>
              <input
                type="text"
                value={content?.secondaryButtonLink || 'tel:+18333333101'}
                onChange={(e) => updateContent('secondaryButtonLink', e.target.value)}
                className="w-full p-2 border rounded"
                placeholder="e.g., tel:+18333333101"
              />
            </div>
            
            <div className="mb-4">
              <label className="block text-sm font-medium mb-1">Phone Number</label>
              <input
                type="text"
                value={content?.phoneNumber || '+18333333101'}
                onChange={(e) => updateContent('phoneNumber', e.target.value)}
                className="w-full p-2 border rounded"
                placeholder="e.g., +18333333101"
              />
            </div>
            
            <div className="mb-4">
              <label className="block text-sm font-medium mb-1">Button Color</label>
              <ColorPicker
                color={content?.secondaryButtonColor || '#16a34a'}
                onChange={(color) => updateContent('secondaryButtonColor', color)}
              />
            </div>
            
            <div className="mb-4">
              <label className="flex items-center">
                <input
                  type="checkbox"
                  checked={content?.showPhoneIcon !== false}
                  onChange={(e) => updateContent('showPhoneIcon', e.target.checked)}
                  className="mr-2"
                />
                <span className="text-sm">Show Phone Icon</span>
              </label>
            </div>
          </div>
          
          {/* Advanced Settings */}
          <div className="bg-gray-50 p-4 rounded-md">
            <div className="flex justify-between items-center mb-4">
              <h4 className="font-medium">Advanced Settings</h4>
              <div className="text-blue-500">
                <Info size={16} />
              </div>
            </div>
            
            <div className="mb-4">
              <label className="flex items-center">
                <input
                  type="checkbox"
                  checked={content?.showWaveSeparator !== false}
                  onChange={(e) => updateContent('showWaveSeparator', e.target.checked)}
                  className="mr-2"
                />
                <span className="text-sm">Show Wave Separator</span>
              </label>
            </div>
            
            {content?.showWaveSeparator !== false && (
              <div className="mb-4">
                <label className="block text-sm font-medium mb-1">Separator Color</label>
                <ColorPicker
                  color={content?.separatorColor || '#fbfbfb'}
                  onChange={(color) => updateContent('separatorColor', color)}
                />
              </div>
            )}
            
            <div className="mb-4">
              <label className="block text-sm font-medium mb-1">Particles Count</label>
              <input
                type="number"
                min="0"
                max="50"
                value={content?.particlesCount !== undefined ? content.particlesCount : 15}
                onChange={(e) => updateContent('particlesCount', parseInt(e.target.value, 10))}
                className="w-full p-2 border rounded"
              />
              <p className="text-xs text-gray-500 mt-1">Set to 0 to disable particles</p>
            </div>
            
            {content?.particlesCount > 0 && (
              <div className="mb-4">
                <label className="block text-sm font-medium mb-1">Particles Color</label>
                <ColorPicker
                  color={content?.particlesColor || 'rgba(255, 255, 255, 0.2)'}
                  onChange={(color) => updateContent('particlesColor', color)}
                  allowAlpha={true}
                />
              </div>
            )}
            
            <div className="mb-4">
              <label className="flex items-center">
                <input
                  type="checkbox"
                  checked={content?.animationEnabled !== false}
                  onChange={(e) => updateContent('animationEnabled', e.target.checked)}
                  className="mr-2"
                />
                <span className="text-sm">Enable Animations</span>
              </label>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SlideShowHeaderWaveForm;








// // src/components/admin/page-management/section-forms/SlideShowHeaderWaveForm.js
// import React, { useState } from 'react';
// import { Info } from 'lucide-react';
// import ColorPicker from '../../shared/ColorPicker';
// import MediaLibrary from '../../shared/MediaUploader';

// const SlideShowHeaderWaveForm = ({ content, updateContent, pageSlug }) => {
//   const [showMediaLibrary, setShowMediaLibrary] = useState(false);
//   const [currentImageField, setCurrentImageField] = useState(null);

//   const handleSelectImage = (imageUrl) => {
//     if (currentImageField) {
//       updateContent(currentImageField, imageUrl);
//       setShowMediaLibrary(false);
//       setCurrentImageField(null);
//     }
//   };

//   const openMediaLibrary = (fieldName) => {
//     setCurrentImageField(fieldName);
//     setShowMediaLibrary(true);
//   };

//   return (
//     <div className="space-y-6">
//       <h3 className="text-lg font-semibold">Hero Banner Section</h3>
      
//       {showMediaLibrary ? (
//         <div className="bg-white rounded-lg shadow-lg p-4">
//           <div className="flex justify-between items-center mb-4">
//             <h4 className="text-lg font-medium">Media Library</h4>
//             <button 
//               onClick={() => setShowMediaLibrary(false)}
//               className="text-gray-500 hover:text-gray-700"
//             >
//               Close
//             </button>
//           </div>
//           <MediaLibrary 
//             onSelect={handleSelectImage} 
//             pageSlug={pageSlug} 
//           />
//         </div>
//       ) : (
//         <>
//           {/* Content and Text Settings */}
//           <div className="bg-gray-50 p-4 rounded-md">
//             <h4 className="font-medium mb-4">Content</h4>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium mb-1">Title</label>
//               <input
//                 type="text"
//                 value={content?.title || 'Paper Bag & Box <span>Custom Packaging</span>'}
//                 onChange={(e) => updateContent('title', e.target.value)}
//                 className="w-full p-2 border rounded"
//               />
//               <p className="text-xs text-gray-500 mt-1">
//                 Use &lt;span&gt;text&lt;/span&gt; to highlight parts of the title
//               </p>
//             </div>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium mb-1">Subtitle</label>
//               <textarea
//                 value={content?.subtitle || 'Elevate your brand with premium quality custom bags and boxes. Perfect for businesses of all sizes.'}
//                 onChange={(e) => updateContent('subtitle', e.target.value)}
//                 className="w-full p-2 border rounded"
//                 rows="3"
//               />
//             </div>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium mb-1">Highlight Color</label>
//               <ColorPicker
//                 color={content?.highlightColor || '#f59e0b'}
//                 onChange={(color) => updateContent('highlightColor', color)}
//               />
//             </div>
//           </div>

//           {/* Background Settings */}
//           <div className="bg-gray-50 p-4 rounded-md">
//             <h4 className="font-medium mb-4">Background Settings</h4>


//             <div className="mb-4">
//               <label className="block text-sm font-medium mb-1">Background Type</label>
//               <div className="flex space-x-4">
//                 <label className="inline-flex items-center">
//                   <input
//                     type="radio"
//                     name="backgroundType"
//                     checked={!content?.videoBackground}
//                     onChange={() => updateContent('videoBackground', false)}
//                     className="mr-2"
//                   />
//                   <span className="text-sm">Image</span>
//                 </label>
//                 <label className="inline-flex items-center">
//                   <input
//                     type="radio"
//                     name="backgroundType"
//                     checked={!!content?.videoBackground}
//                     onChange={() => updateContent('videoBackground', true)}
//                     className="mr-2"
//                   />
//                   <span className="text-sm">Video</span>
//                 </label>
//               </div>
//             </div>


//             {!content?.videoBackground ? (
//               // Image background options (your existing code)
//               <>
//                 <div className="mb-4">
//                   <label className="block text-sm font-medium mb-1">Desktop Background Image</label>
//                   {/* Existing image upload code */}
//                 </div>
                
//                 <div className="mb-4">
//                   <label className="block text-sm font-medium mb-1">Mobile Background Image</label>
//                   {/* Existing mobile image upload code */}
//                 </div>
//               </>
//             ) : (
//               // Video background options
//               <>
//                 <div className="mb-4">
//                   <label className="block text-sm font-medium mb-1">Desktop Background Video</label>
//                   <div className="flex items-center">
//                     <input
//                       type="text"
//                       value={content?.backgroundVideo || ''}
//                       onChange={(e) => updateContent('backgroundVideo', e.target.value)}
//                       className="w-full p-2 border rounded"
//                     />
//                     <button
//                       type="button"
//                       onClick={() => openMediaLibrary('backgroundVideo', 'video')}
//                       className="ml-2 px-3 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
//                     >
//                       Browse
//                     </button>
//                   </div>
//                   {content?.backgroundVideo && (
//                     <div className="mt-2 relative h-20 w-full overflow-hidden rounded border">
//                       <video 
//                         src={content.backgroundVideo} 
//                         className="h-full w-full object-cover"
//                         controls
//                       />
//                     </div>
//                   )}
//                 </div>
                
//                 <div className="mb-4">
//                   <label className="block text-sm font-medium mb-1">Mobile Background Video</label>
//                   <div className="flex items-center">
//                     <input
//                       type="text"
//                       value={content?.mobileBackgroundVideo || ''}
//                       onChange={(e) => updateContent('mobileBackgroundVideo', e.target.value)}
//                       className="w-full p-2 border rounded"
//                     />
//                     <button
//                       type="button"
//                       onClick={() => openMediaLibrary('mobileBackgroundVideo', 'video')}
//                       className="ml-2 px-3 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
//                     >
//                       Browse
//                     </button>
//                   </div>
//                   {content?.mobileBackgroundVideo && (
//                     <div className="mt-2 relative h-20 w-full overflow-hidden rounded border">
//                       <video 
//                         src={content.mobileBackgroundVideo} 
//                         className="h-full w-full object-cover"
//                         controls
//                       />
//                     </div>
//                   )}
//                 </div>
                
//                 <div className="mb-4">
//                   <label className="block text-sm font-medium mb-1">Video Poster Image (Fallback)</label>
//                   <div className="flex items-center">
//                     <input
//                       type="text"
//                       value={content?.videoPoster || ''}
//                       onChange={(e) => updateContent('videoPoster', e.target.value)}
//                       className="w-full p-2 border rounded"
//                     />
//                     <button
//                       type="button"
//                       onClick={() => openMediaLibrary('videoPoster')}
//                       className="ml-2 px-3 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
//                     >
//                       Browse
//                     </button>
//                   </div>
//                 </div>
                
//                 <div className="grid grid-cols-3 gap-4">
//                   <div className="mb-4">
//                     <label className="flex items-center">
//                       <input
//                         type="checkbox"
//                         checked={content?.videoAutoplay !== false}
//                         onChange={(e) => updateContent('videoAutoplay', e.target.checked)}
//                         className="mr-2"
//                       />
//                       <span className="text-sm">Autoplay</span>
//                     </label>
//                   </div>
//                   <div className="mb-4">
//                     <label className="flex items-center">
//                       <input
//                         type="checkbox"
//                         checked={content?.videoLoop !== false}
//                         onChange={(e) => updateContent('videoLoop', e.target.checked)}
//                         className="mr-2"
//                       />
//                       <span className="text-sm">Loop</span>
//                     </label>
//                   </div>
//                   <div className="mb-4">
//                     <label className="flex items-center">
//                       <input
//                         type="checkbox"
//                         checked={content?.videoMuted !== false}
//                         onChange={(e) => updateContent('videoMuted', e.target.checked)}
//                         className="mr-2"
//                       />
//                       <span className="text-sm">Muted</span>
//                     </label>
//                   </div>
//                 </div>
//               </>
//             )}
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium mb-1">Desktop Background Image</label>
//               <div className="flex items-center">
//                 <input
//                   type="text"
//                   value={content?.backgroundImage || '/images/s1.jpg'}
//                   onChange={(e) => updateContent('backgroundImage', e.target.value)}
//                   className="w-full p-2 border rounded"
//                 />
//                 <button
//                   type="button"
//                   onClick={() => openMediaLibrary('backgroundImage')}
//                   className="ml-2 px-3 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
//                 >
//                   Browse
//                 </button>
//               </div>
//               {content?.backgroundImage && (
//                 <div className="mt-2 relative h-20 w-full overflow-hidden rounded border">
//                   <img 
//                     src={content.backgroundImage} 
//                     alt="Background Preview" 
//                     className="h-full w-full object-cover"
//                   />
//                 </div>
//               )}
//             </div>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium mb-1">Mobile Background Image</label>
//               <div className="flex items-center">
//                 <input
//                   type="text"
//                   value={content?.mobileBackgroundImage || '/images/s3.jpg'}
//                   onChange={(e) => updateContent('mobileBackgroundImage', e.target.value)}
//                   className="w-full p-2 border rounded"
//                 />
//                 <button
//                   type="button"
//                   onClick={() => openMediaLibrary('mobileBackgroundImage')}
//                   className="ml-2 px-3 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
//                 >
//                   Browse
//                 </button>
//               </div>
//               {content?.mobileBackgroundImage && (
//                 <div className="mt-2 relative h-20 w-full overflow-hidden rounded border">
//                   <img 
//                     src={content.mobileBackgroundImage} 
//                     alt="Mobile Background Preview" 
//                     className="h-full w-full object-cover"
//                   />
//                 </div>
//               )}
//             </div>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium mb-1">Overlay Color</label>
//               <ColorPicker
//                 color={content?.overlayColor || 'rgba(0,0,0,0.5)'}
//                 onChange={(color) => updateContent('overlayColor', color)}
//                 allowAlpha={true}
//               />
//             </div>
            
//             <div className="grid grid-cols-2 gap-4 mb-4">
//               <div>
//                 <label className="block text-sm font-medium mb-1">Height</label>
//                 <input
//                   type="text"
//                   value={content?.height || '100vh'}
//                   onChange={(e) => updateContent('height', e.target.value)}
//                   className="w-full p-2 border rounded"
//                   placeholder="e.g., 100vh, 800px"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium mb-1">Min Height</label>
//                 <input
//                   type="text"
//                   value={content?.minHeight || '600px'}
//                   onChange={(e) => updateContent('minHeight', e.target.value)}
//                   className="w-full p-2 border rounded"
//                   placeholder="e.g., 600px"
//                 />
//               </div>
//             </div>
//           </div>
          
//           {/* Primary Button Settings */}
//           <div className="bg-gray-50 p-4 rounded-md">
//             <h4 className="font-medium mb-4">Primary Button</h4>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium mb-1">Button Text</label>
//               <input
//                 type="text"
//                 value={content?.primaryButtonText || 'Customize Products'}
//                 onChange={(e) => updateContent('primaryButtonText', e.target.value)}
//                 className="w-full p-2 border rounded"
//               />
//             </div>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium mb-1">Button Link</label>
//               <input
//                 type="text"
//                 value={content?.primaryButtonLink || '/products'}
//                 onChange={(e) => updateContent('primaryButtonLink', e.target.value)}
//                 className="w-full p-2 border rounded"
//                 placeholder="e.g., /products"
//               />
//             </div>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium mb-1">Button Color</label>
//               <ColorPicker
//                 color={content?.primaryButtonColor || '#d97706'}
//                 onChange={(color) => updateContent('primaryButtonColor', color)}
//               />
//             </div>
//           </div>
          
//           {/* Secondary Button Settings */}
//           <div className="bg-gray-50 p-4 rounded-md">
//             <h4 className="font-medium mb-4">Secondary Button</h4>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium mb-1">Button Text</label>
//               <input
//                 type="text"
//                 value={content?.secondaryButtonText || 'Call to Order'}
//                 onChange={(e) => updateContent('secondaryButtonText', e.target.value)}
//                 className="w-full p-2 border rounded"
//               />
//               <p className="text-xs text-gray-500 mt-1">Leave empty to hide the secondary button</p>
//             </div>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium mb-1">Button Link</label>
//               <input
//                 type="text"
//                 value={content?.secondaryButtonLink || 'tel:+18333333101'}
//                 onChange={(e) => updateContent('secondaryButtonLink', e.target.value)}
//                 className="w-full p-2 border rounded"
//                 placeholder="e.g., tel:+18333333101"
//               />
//             </div>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium mb-1">Phone Number</label>
//               <input
//                 type="text"
//                 value={content?.phoneNumber || '+18333333101'}
//                 onChange={(e) => updateContent('phoneNumber', e.target.value)}
//                 className="w-full p-2 border rounded"
//                 placeholder="e.g., +18333333101"
//               />
//             </div>
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium mb-1">Button Color</label>
//               <ColorPicker
//                 color={content?.secondaryButtonColor || '#16a34a'}
//                 onChange={(color) => updateContent('secondaryButtonColor', color)}
//               />
//             </div>
            
//             <div className="mb-4">
//               <label className="flex items-center">
//                 <input
//                   type="checkbox"
//                   checked={content?.showPhoneIcon !== false}
//                   onChange={(e) => updateContent('showPhoneIcon', e.target.checked)}
//                   className="mr-2"
//                 />
//                 <span className="text-sm">Show Phone Icon</span>
//               </label>
//             </div>
//           </div>
          
//           {/* Advanced Settings */}
//           <div className="bg-gray-50 p-4 rounded-md">
//             <div className="flex justify-between items-center mb-4">
//               <h4 className="font-medium">Advanced Settings</h4>
//               <div className="text-blue-500">
//                 <Info size={16} />
//               </div>
//             </div>
            
//             <div className="mb-4">
//               <label className="flex items-center">
//                 <input
//                   type="checkbox"
//                   checked={content?.showWaveSeparator !== false}
//                   onChange={(e) => updateContent('showWaveSeparator', e.target.checked)}
//                   className="mr-2"
//                 />
//                 <span className="text-sm">Show Wave Separator</span>
//               </label>
//             </div>
            
//             {content?.showWaveSeparator !== false && (
//               <div className="mb-4">
//                 <label className="block text-sm font-medium mb-1">Separator Color</label>
//                 <ColorPicker
//                   color={content?.separatorColor || '#fbfbfb'}
//                   onChange={(color) => updateContent('separatorColor', color)}
//                 />
//               </div>
//             )}
            
//             <div className="mb-4">
//               <label className="block text-sm font-medium mb-1">Particles Count</label>
//               <input
//                 type="number"
//                 min="0"
//                 max="50"
//                 value={content?.particlesCount !== undefined ? content.particlesCount : 15}
//                 onChange={(e) => updateContent('particlesCount', parseInt(e.target.value, 10))}
//                 className="w-full p-2 border rounded"
//               />
//               <p className="text-xs text-gray-500 mt-1">Set to 0 to disable particles</p>
//             </div>
            
//             {content?.particlesCount > 0 && (
//               <div className="mb-4">
//                 <label className="block text-sm font-medium mb-1">Particles Color</label>
//                 <ColorPicker
//                   color={content?.particlesColor || 'rgba(255, 255, 255, 0.2)'}
//                   onChange={(color) => updateContent('particlesColor', color)}
//                   allowAlpha={true}
//                 />
//               </div>
//             )}
            
//             <div className="mb-4">
//               <label className="flex items-center">
//                 <input
//                   type="checkbox"
//                   checked={content?.animationEnabled !== false}
//                   onChange={(e) => updateContent('animationEnabled', e.target.checked)}
//                   className="mr-2"
//                 />
//                 <span className="text-sm">Enable Animations</span>
//               </label>
//             </div>
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

// export default SlideShowHeaderWaveForm;